module["exports"] = [
  "/6011-####-####-###L/",
  "/65##-####-####-###L/",
  "/64[4-9]#-####-####-###L/",
  "/6011-62##-####-####-###L/",
  "/65##-62##-####-####-###L/",
  "/64[4-9]#-62##-####-####-###L/"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/credit_card/discover.js
// module id = 712
// module chunks = 0